import React, { Fragment, useState, useEffect } from "react";
import { Image, Col, Row, Form, Button } from "react-bootstrap";
import LeftSideNavigation from "../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import {
  addNewUser,
  getCrusines,
  getFavChains,
  getDietaryPref,
  getAllergies,
  getFavPlaces,
  checkIfEmailExists,
  checkIfPhoneExists,
  getAllCountries,
  getAllStateFromCountry,
  getAllCityFromState,
} from "../../../../store/actions/SuperAdminActions/adminCategoryAndIconsAction";

import {
  TextField,
  IconButton,
  InputLabel,
  FormControl,
  Select,
} from "@material-ui/core";
import { Scrollbars } from "react-custom-scrollbars";
import Switch from "react-switch";
import { useFormik } from "formik";
import * as yup from "yup";
import {
  getCountries,
  getCountryCallingCode,
} from "react-phone-number-input/input";
import en from "react-phone-number-input/locale/en.json";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import axios from "axios";
import { serverApi, imageUploadSize } from "../../../../config/Keys";
import Alert from "react-s-alert";
import { AmealioLoader } from "../../../Loader/AmealioLoader";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";

const phoneRegExp =
  /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

const validationSchema = yup.object({
  first_name: yup
    .string()
    .required("First name is required")
    .min(1, "Minimum 1 Character")
    .max(64, "Maximum 64 Character"),
  last_name: yup
    .string()
    .required("Last name is required")
    .min(1, "Minimum 1 Character")
    .max(64, "Maximum 64 Character"),
  mobile_number: yup
    .string()
    .required("Phone number is required")
    .matches(phoneRegExp, "Please enter valid Phone Number")
    .min(10, "Please enter valid Phone Number")
    .max(10, "Please enter valid Phone Number"),
  email: yup
    .string()
    .email("Please enter valid Email address")
    .required("Please enter your email"),
  password: yup
    .string()
    .required("Please enter your password")
    .matches(
      /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/,
      "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and one special case Character"
    ),
  country: yup.string().required("Please select country"),
  state: yup.string().required("Please select state"),
  city: yup.string().required("Please select city"),

  //.matches(/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{6,}$/,"Must Contain 6 Characters, One Uppercase, One Lowercase, One Number and one special case Character")
});

const validate = (values) => {
  const errors = {};

  if (!values.gender) {
    errors.gender = "Please select gender";
  }
  if (!values.age) {
    errors.age = "Please select age";
  }
  if (values.birthday_day) {
    if (!values.birthday_month) {
      errors.birthday_month = "Please enter month";
    }
    if (values.birthday_day > 31 || values.birthday_day === 0) {
      errors.birthday_day = "Date should be between 1-31";
    }
  }
  if (values.birthday_month) {
    if (!values.birthday_day) {
      errors.birthday_day = "Please enter day";
    }
    if (values.birthday_month > 12 || values.birthday_month === 0) {
      errors.birthday_month = "Month should be between 1-12";
    }
  }
  if (values.anniversary_day) {
    if (!values.anniversary_month) {
      errors.anniversary_month = "Please enter month";
    }
    if (values.anniversary_day > 31 || values.anniversary_day === 0) {
      errors.anniversary_day = "Date should be between 1-31";
    }
  }
  if (values.anniversary_month) {
    if (!values.anniversary_day) {
      errors.anniversary_day = "Please enter day";
    }
    if (values.anniversary_month > 12 || values.anniversary_month === 0) {
      errors.anniversary_month = "Month should be between 1-12";
    }
  }
  return errors;
};

const AddUser = (props) => {
  //state
  const [loading, setLoading] = useState();
  const [ShowTab, setShowTab] = useState("1");
  const [are_you_over_21, setAre_You_Over_21] = useState(false);
  const [profilePhoto, setProfilePhoto] = useState();
  const formik1 = useFormik({
    initialValues: {
      first_name: "",
      last_name: "",
      email: "",
      mobile_number: "",
      password: "",
      address: "",
      address1: "",
      city: "",
      state: "",
      country: "",
      country_id: "",
      state_id: "",
      city_id: "",
    },
    validationSchema,

    onSubmit: (values) => {
      var email = {};
      email.email = values.email;

      var phone = {};
      phone.phone = values.mobile_number;
      //formik1.errors.email = "email is already registered";
      const onSuccessEmailStatus = (status) => {
        if (status.status) {
          Alert.error(`<h4>Email is already registered</h4>`, {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          });
        } else {
          //handleShowTab("2");
          props.checkIfPhoneExists(phone, onSuccessPhoneStatus);
        }
      };
      const onSuccessPhoneStatus = (status) => {
        if (status.status) {
          // formik1.errors.email = "email is already registered";
          Alert.error(`<h4>Phone no is already registered</h4>`, {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          });
        } else {
          handleShowTab("2");
        }
      };
      props.checkIfEmailExists(email, onSuccessEmailStatus);
    },
  });

  const handleChangeCode = (event) => {
    const code = event.target.name;
    setState({
      ...state,
      [code]: event.target.value,
    });
  };
  const handleShowTab = (e) => setShowTab(e);
  const handleChangeSwitch = (e) => {
    setAge([
      { name: "15-20", status: false },
      { name: "21-30", status: false },
      { name: "31-40", status: false },
      { name: "41-50", status: false },
      { name: "51>", status: false },
    ]);
    formikStep2.setFieldValue("age", "");
    setAre_You_Over_21({ are_you_over_21: !are_you_over_21.are_you_over_21 });
  };
  const [state, setState] = useState({
    code: props.auth.user.VendorUser.country_code,
    Language: "English",
  });
  // step 2
  const [gender, setGender] = useState([
    { name: "Male", status: true },
    { name: "Female", status: false },
    { name: "Other", status: false },
    { name: "Can't Say", status: false },
  ]);
  const handleGenderChange = (gen) => {
    var genderStatusChange = gender.map((gender) => {
      if (gender.name === gen) {
        return { ...gender, status: true };
      } else {
        return { ...gender, status: false };
      }
    });
    setGender(genderStatusChange);
    formikStep2.setFieldValue("gender", gen);
  };
  const [age, setAge] = useState([
    { name: "15-20", status: true },
    { name: "21-30", status: false },
    { name: "31-40", status: false },
    { name: "51>", status: false },
  ]);

  const handleAgeChange = (age1) => {
    var ageStatusChange = age.map((age) => {
      if (age.name === age1) {
        return { ...age, status: true };
      } else {
        return { ...age, status: false };
      }
    });
    setAge(ageStatusChange);

    formikStep2.setFieldValue("age", age1);
  };

  const formikStep2 = useFormik({
    initialValues: {
      gender: "Male",
      age: "20-30",
      birthday_day: "",
      birthday_month: "",
      anniversary_day: "",
      anniversary_month: "",
    },
    //validationSchema={validationSchemaa},
    //validationSchema,
    validate,
    onSubmit: (values) => {
      handleShowTab("3");
    },
  });

  const handleChangeLanguage = (event) => {
    const Language = event.target.name;
    setState({
      ...state,
      [Language]: event.target.value,
    });
  };

  const uploadImage = (e) => {
    if (e.target.files) {
      if (e.target.files[0].size > imageUploadSize) {
        alert("File is too Big");
      } else {
        const data = new FormData();
        data.append("files", e.target.files[0]);
        //setFile(URL.createObjectURL(e.target.files[0]));

        axios
          .post(
            `${serverApi}/upload-assets?uploadSide=superadminCategoryicon`,
            data,
            {
              headers: {
                "content-type": "multipart/form-data",
              },
            }
          )
          .then((res) => {
            setProfilePhoto(res.data);
          })
          .catch((err) => {
            Alert.error(`<h4>Error while uploading the image</h4>`, {
              position: "top-right",
              effect: "bouncyflip",
              beep: true,
              html: true,
              timeout: 3000,
              offset: 35,
            });
          });
      }
    }
  };

  //step3
  const [tempInput, setTempInput] = useState([]);
  const [inputFields, setInputFields] = useState([]);

  const handleAddFields = () => {
    const values = [];
    values.push({
      special_occasion: "",
      special_occasion_day: "",
      special_occasion_month: "",
    });
    setTempInput(values);
  };

  const handleInputChange = (index, event) => {
    const values = [...tempInput];
    if (event.target.name === "special_occasion") {
      values[index].special_occasion = event.target.value;
    } else if (event.target.name === "special_occasion_day") {
      values[index].special_occasion_day = event.target.value;
    } else {
      values[index].special_occasion_month = event.target.value;
    }

    setTempInput(values);
    //props.onChangeData(values,index)
    // /props.onchange(values,props.name)
  };

  const onAddOccassion = (e) => {
    e.preventDefault();
    setInputFields([...inputFields, tempInput[0]]);
    setTempInput([]);
  };

  const onEditInputField = (index) => {
    setTempInput([inputFields[index]]);
    var data = [...inputFields];
    data.splice(index, 1);
    setInputFields(data);
  };

  const onRemoveInputField = (index) => {
    var data = [...inputFields];
    data.splice(index, 1);
    setInputFields(data);

    //setInputFields(values);
  };

  //step4

  const [days, setDays] = useState([
    { name: "Mon", status: false },
    { name: "Tue", status: false },
    { name: "Wed", status: false },
    { name: "Thu", status: false },
    { name: "Fri", status: false },
    { name: "Sat", status: false },
    { name: "Sun", status: false },
    { name: "All", status: false },
  ]);

  const onChangeDaysEatOut = (day) => {
    if (day.name === "All") {
      //setRemoveOtherDays(false);
      var removeOtherDays = days.map((data) => {
        if (data.name !== "All") {
          return { ...data, status: false };
        } else {
          return { ...data, status: true };
        }
      });
      setDays(removeOtherDays);
      //setDaysEatOut([day.name]);
    } else {
      var changeDayStatus = days.map((data) => {
        if (data.name === day.name) {
          return { ...data, status: !data.status };
        } else if (data.name === "All") {
          return { ...data, status: false };
        } else {
          return { ...data };
        }
      });
      setDays(changeDayStatus);
    }
  };

  const [popularCuisines, setPopularCrusines] = useState([]);
  const [selectedCruisines, setSelectedCrusines] = useState([]);

  const onChangeAddCrusines = (item, id) => {
    var statusChange = popularCuisines.map((data) => {
      if (data.id === id) {
        return { ...data, status: true };
      } else {
        return data;
      }
    });
    setPopularCrusines(statusChange);
    const data = [];
    data.name = item;
    data.id = id;
    setSelectedCrusines([...selectedCruisines, data]);
  };
  const onRemoveCruises = (id) => {
    var statusChange = popularCuisines.map((data) => {
      if (data.id === id) {
        return { ...data, status: false };
      } else {
        return data;
      }
    });
    setPopularCrusines(statusChange);
    var filteredCruises = selectedCruisines.filter(
      (crusine) => crusine.id !== id
    );
    setSelectedCrusines(filteredCruises);
  };

  const [favPlaces, setFavPlaces] = useState([]);
  const [selectedFavPlaces, setSelectedFavPlaces] = useState([]);

  const onChangeAddFavPlaces = (item, id) => {
    var statusChange = favPlaces.map((data) => {
      if (data.id === id) {
        return { ...data, status: true };
      } else {
        return data;
      }
    });

    setFavPlaces(statusChange);
    const data1 = [];
    data1.name = item;
    data1.id = id;
    setSelectedFavPlaces([...selectedFavPlaces, data1]);
  };
  const onRemoveFavPlaces = (id) => {
    var statusChange = favPlaces.map((data) => {
      if (data.id === id) {
        return { ...data, status: false };
      } else {
        return data;
      }
    });
    setFavPlaces(statusChange);
    var filteredFavPlaces = selectedFavPlaces.filter(
      (favPlace) => favPlace.id !== id
    );
    setSelectedFavPlaces(filteredFavPlaces);
  };

  const [dietaryPref, setDietaryPref] = useState([]);
  const [selectedDietaryPref, setSelectedDietaryPref] = useState([]);

  const onChangeAddDietaryPref = (item, id) => {
    var statusChange = dietaryPref.map((data) => {
      if (data.id === id) {
        return { ...data, status: true };
      } else {
        return data;
      }
    });

    setDietaryPref(statusChange);
    const data1 = [];
    data1.name = item;
    data1.id = id;
    setSelectedDietaryPref([...selectedDietaryPref, data1]);
  };
  const onRemoveDietaryPref = (id) => {
    var statusChange = dietaryPref.map((data) => {
      if (data.id === id) {
        return { ...data, status: false };
      } else {
        return data;
      }
    });
    setDietaryPref(statusChange);
    var filteredDietPref = selectedDietaryPref.filter(
      (favPlace) => favPlace.id !== id
    );
    setSelectedDietaryPref(filteredDietPref);
  };

  const [checkboxDietary, setCheckedBoxDietary] = useState(false);
  const handleChangeSwitchDietary = (e) => {
    setCheckedBoxDietary({ checkboxDietary: !checkboxDietary.checkboxDietary });
  };

  const [checkedBoxAllergies, setCheckedBoxAllergies] = useState(false);
  const handleChangeSwitchAllergies = (e) => {
    setCheckedBoxAllergies({
      checkedBoxAllergies: !checkedBoxAllergies.checkedBoxAllergies,
    });
  };

  const [allergies, setAllergies] = useState([]);
  const [selectedAllergies, setSelectedAllergies] = useState([]);

  const onChangeAddAllergies = (item, id) => {
    var statusChange = allergies.map((data) => {
      if (data.id === id) {
        return { ...data, status: true };
      } else {
        return data;
      }
    });

    setAllergies(statusChange);
    const data1 = [];
    data1.name = item;
    data1.id = id;
    setSelectedAllergies([...selectedAllergies, data1]);
  };
  const onRemoveAllergies = (id) => {
    var statusChange = allergies.map((data) => {
      if (data.id === id) {
        return { ...data, status: false };
      } else {
        return data;
      }
    });
    setAllergies(statusChange);
    var filteredAllergies = selectedAllergies.filter(
      (favPlace) => favPlace.id !== id
    );
    setSelectedAllergies(filteredAllergies);
  };

  //step 5

  const [favChains, setFavChains] = useState([]);
  const [selectedFavChains, setSelectedFavChains] = useState([]);

  const onChangeAddFavChains = (item, id, icon) => {
    var statusChange = favChains.map((data) => {
      if (data.id === id) {
        return { ...data, status: true };
      } else {
        return data;
      }
    });

    setFavChains(statusChange);
    const data1 = [];
    data1.name = item;
    data1.id = id;
    data1.icon = icon;
    setSelectedFavChains([...selectedFavChains, data1]);
  };
  const onRemoveFavChains = (id) => {
    var statusChange = favChains.map((data) => {
      if (data.id === id) {
        return { ...data, status: false };
      } else {
        return data;
      }
    });
    setFavChains(statusChange);
    var filteredFavChains = selectedFavChains.filter(
      (favChains) => favChains.id !== id
    );
    setSelectedFavChains(filteredFavChains);
  };

  const onSuccessAdd = () => {
    setLoading(false);
    props.history.push(`/superadminallusers`);
  };

  //submit data
  const submitData = () => {
    setLoading(true);
    let perpareData = {};
    perpareData = { ...formik1.values, ...formikStep2.values };
    perpareData.country_code = state.code;
    perpareData.language = state.Language;

    var profilePic = [];
    if (profilePhoto === null || profilePhoto === undefined) {
      perpareData.profile_photo = profilePic;
    } else {
      var profile = profilePhoto;
      perpareData.profile_photo = [profile];
    }
    perpareData.address = "";

    //step 3
    let occasion = [];
    for (let i = 0; i < inputFields.length; i++) {
      occasion.push(inputFields[i]);
    }
    perpareData.occasion = occasion;
    //step 4
    let day_you_eat_out = [];
    for (let i = 0; i < days.length; i++) {
      if (days[i].status) {
        day_you_eat_out.push(days[i].name);
      }
    }

    perpareData.day_you_eat_out = day_you_eat_out;
    let selected_cuisine = [];
    for (let i = 0; i < selectedCruisines.length; i++) {
      selected_cuisine.push(selectedCruisines[i].id);
    }

    perpareData.selected_cuisine = selected_cuisine;
    let favourite_places = [];
    for (let i = 0; i < selectedFavPlaces.length; i++) {
      favourite_places.push(selectedFavPlaces[i].id);
    }
    perpareData.favourite_places = favourite_places;

    let dietary_preferences = [];
    for (let i = 0; i < selectedDietaryPref.length; i++) {
      dietary_preferences.push(selectedDietaryPref[i].id);
    }
    perpareData.dietary_preferences = dietary_preferences;
    let do_you_have_allergies = [];
    for (let i = 0; i < selectedAllergies.length; i++) {
      do_you_have_allergies.push(selectedAllergies[i].id);
    }
    perpareData.do_you_have_allergies = do_you_have_allergies;

    perpareData.dietary_preferences_flag = checkboxDietary.checkboxDietary;
    perpareData.allergies_flag = checkedBoxAllergies.checkedBoxAllergies;

    //step 5
    let selected_chain = [];
    for (let i = 0; i < selectedFavChains.length; i++) {
      selected_chain.push(selectedFavChains[i].id);
    }
    perpareData.selected_chain = selected_chain;
    const token = props.auth.user.accessToken;

    props.addNewUser(perpareData, token, onSuccessAdd);
  };

  const onSuccessGetCrusines = (data) => {
    let crusines = [];

    for (let i = 0; i < data.length; i++) {
      crusines.push({ name: data[i].title, status: false, id: data[i]._id });
    }
    setPopularCrusines(crusines);
  };

  const onErrorGetCruisnes = () => {};

  const onSuccessGetFavPlaces = (data) => {
    let fav = [];
    for (let i = 0; i < data.length; i++) {
      fav.push({ name: data[i].title, status: false, id: data[i]._id });
    }
    setFavPlaces(fav);
  };

  const onErrorGetFavPlaces = () => {};

  const onSuccessGetFavChain = (data) => {
    let favC = [];
    for (let i = 0; i < data.length; i++) {
      favC.push({
        name: data[i].title,
        status: false,
        id: data[i]._id,
        icon: data[i].icon,
      });
    }
    setFavChains(favC);
  };

  const onErrorGetFavChain = () => {};

  const onSuccessGetDietaryPref = (data) => {
    let dietaryP = [];
    for (let i = 0; i < data.length; i++) {
      dietaryP.push({ name: data[i].title, status: false, id: data[i]._id });
    }
    setDietaryPref(dietaryP);
  };

  const onErrorGetDietaryPref = () => {};

  const onSuccessAllergies = (data) => {
    let allergiesI = [];
    for (let i = 0; i < data.length; i++) {
      allergiesI.push({ name: data[i].title, status: false, id: data[i]._id });
    }
    setAllergies(allergiesI);
  };

  const onErrorGetAllergies = () => {};

  useEffect(() => {
    props.getCrusines(onSuccessGetCrusines, onErrorGetCruisnes);
    props.getFavPlaces(onSuccessGetFavPlaces, onErrorGetFavPlaces);
    props.getFavChains(onSuccessGetFavChain, onErrorGetFavChain);
    props.getDietaryPref(onSuccessGetDietaryPref, onErrorGetDietaryPref);
    props.getAllergies(onSuccessAllergies, onErrorGetAllergies);
    formik1.values.email = "";
  }, []);

  const [count, setCount] = useState(1);
  const onClickStepOne = () => {
    setCount(count + 1);
    formik1.handleSubmit();
  };

  useEffect(() => {
    if (formik1.errors && formik1.errors.first_name) {
      let firstNameElement = document.getElementById("first_name");
      firstNameElement.focus();
    } else if (formik1.errors && formik1.errors.last_name) {
      let lastNameElement = document.getElementById("last_name");
      lastNameElement.focus();
    } else if (formik1.errors && formik1.errors.email) {
      let emailElement = document.getElementById("email");
      emailElement.focus();
    } else if (formik1.errors && formik1.errors.mobile_number) {
      let mobileElement = document.getElementById("mobile_number");
      mobileElement.focus();
    } else if (formik1.errors && formik1.errors.password) {
      let passwordElement = document.getElementById("password");
      passwordElement.focus();
    }
  }, [count]);

  const [data, setData] = useState({ country: "", state: "", city: "" });

  const onChangeCountry = (e) => {
    props.getAllStateFromCountry(e.target.value, onSuccessGetAllStates);

    setData({
      [e.target.name]: e.target.value,
      state: "",
      city: "",
    });

    formik1.setFieldValue("city", "");
    formik1.setFieldValue("city_id", "");
    formik1.setFieldValue("state_id", "");
    formik1.setFieldValue("state", "");

    for (let i = 0; i < countries.length; i++) {
      if (e.target.value === countries[i].id) {
        formik1.setFieldValue("country", countries[i].name);
        formik1.setFieldValue("country_id", countries[i].id);
        break;
      }
    }
  };

  const onChangeState = (e) => {
    props.getAllCityFromState(e.target.value, onSuccessGetAllCity);
    setData({
      country: data.country,
      [e.target.name]: e.target.value,
      city: "",
    });

    formik1.setFieldValue("city", "");
    formik1.setFieldValue("city_id", "");
    for (let i = 0; i < states.length; i++) {
      if (e.target.value === states[i].id) {
        formik1.setFieldValue("state", states[i].name);
        formik1.setFieldValue("state_id", states[i].id);
        break;
      }
    }
  };

    const maxLengthCheck = (object) => {
    if (object.target.value.length > object.target.maxLength) {
      object.target.value = object.target.value.slice(
        0,
        object.target.maxLength
      );
    }
  };

  const onChangeCity = (e) => {
    setData({
      ...data,
      [e.target.name]: e.target.value,
    });
    for (let i = 0; i < city.length; i++) {
      if (e.target.value === city[i].id) {
        formik1.setFieldValue("city", city[i].name);
        formik1.setFieldValue("city_id", city[i].id);
        break;
      }
    }
  };

  const [countries, setAllCountries] = useState([]);
  const [states, setAllStates] = useState([]);
  const [city, setAllCity] = useState([]);

  const onSuccessGetAllCountries = (allData) => {
    setAllCountries(allData);
    if (
      props &&
      props.auth &&
      props.auth.user &&
      props.auth.user.VendorUser.country
    ) {
      for (let i = 0; i < allData.length; i++) {
        if (props.auth.user.VendorUser.country === allData[i].iso2) {
          let e = {};
          e.target = {};
          e.target.value = allData[i].id;
          e.target.name = "country";
          onChangeCountry(e, "any");
          formik1.setFieldValue("country", allData[i].name);
          formik1.setFieldValue("country_id", allData[i].id);

          break;
        }
      }
    }
  };

  const onSuccessGetAllStates = (data) => {
    setAllStates(data);
  };

  const onSuccessGetAllCity = (data) => {
    setAllCity(data);
  };

  useEffect(() => {
    props.getAllCountries(onSuccessGetAllCountries);
  }, []);

  return (
    <>
      {!loading ? <></> : <AmealioLoader />}

      <div className="container-fluid">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation displayLink={1} />
          </div>
          <div className="super-admin-right-side-panel">
            <HomeReusableTopBarNavigation displayText="All Users" />
            <Col>
              <Col className="d-flex justify-content-between align-items-center pt-4 pb-3">
                <div className="f24_700_HelveticaNeue">Add User</div>
              </Col>
            </Col>
            <div className="super-admin-inside-right-side-panel">
              <div>
                <div className="py-4 d-flex flex-wrap align-items-center">
                  <Button
                    variant="link"
                    className={`px-0 mr-4 text-grayLink f15-500 ${
                      ShowTab === "1" ? "active" : ""
                    }`}
                  >
                    Personal
                  </Button>
                  <Button
                    variant="link"
                    className={`px-0 mr-4 text-grayLink f15-500 ${
                      ShowTab === "2" ? "active" : ""
                    }`}
                  >
                    About
                  </Button>
                  <Button
                    variant="link"
                    className={`px-0 mr-4 text-grayLink f15-500 ${
                      ShowTab === "3" ? "active" : ""
                    }`}
                  >
                    Special Occassion
                  </Button>
                  <Button
                    variant="link"
                    className={`px-0 mr-4 text-grayLink f15-500 ${
                      ShowTab === "4" ? "active" : ""
                    }`}
                  >
                    Personal preferences
                  </Button>
                  <Button
                    variant="link"
                    className={`px-0 text-grayLink f15-500 ${
                      ShowTab === "5" ? "active" : ""
                    }`}
                  >
                    Favourite hotel/restaurants
                  </Button>
                </div>
                {ShowTab === "1" && (
                  <div className="row">
                    <Form className="col-xl-8 col-lg-10 col-md-12 pb-5">
                      <Row>
                        <Col md={6}>
                          <Row>
                            <Col xs={4} className="pr-0">
                              <FormControl variant="outlined" className="w-100">
                                <Select
                                  value={state.code}
                                  onChange={handleChangeCode}
                                  inputProps={{
                                    name: "code",
                                  }}
                                >
                                  <option value={state.country_code}>
                                    {state.country_code}
                                  </option>
                                  {getCountries().map((country) => (
                                    <option
                                      key={country}
                                      value={
                                        "+" + getCountryCallingCode(country)
                                      }
                                    >
                                      {en[country]} (+
                                      {getCountryCallingCode(country)})
                                    </option>
                                  ))}
                                </Select>
                              </FormControl>
                            </Col>
                            <Col xs={8}>
                              <Form.Group>
                                <TextField
                                  id="mobile_number"
                                  //id="outlined-basic"
                                  type="number"
                                  max="10"
                                  label="Phone Number"
                                  variant="outlined"
                                  className={`w-100  ${
                                    formik1.errors.mobile_number &&
                                    formik1.touched.mobile_number
                                      ? "enError"
                                      : ""
                                  }`}
                                  name="mobile_number"
                                  onInput={maxLengthCheck}
                                  inputProps={{ maxLength: 10 }}
                                  //onKeyDown={InputNumberFunc}
                                  onKeyPress={(event) => {
                                    if (!/[0-9]/.test(event.key)) {
                                      event.preventDefault();
                                    }
                                  }}
                                  onChange={formik1.handleChange}
                                  value={formik1.values.mobile_number}
                                  onBlur={formik1.handleBlur}
                                  //onInvalid={formik1.errors.email && formik1.touched.email}
                                  isInvalid={
                                    formik1.errors.mobile_number &&
                                    formik1.touched.mobile_number
                                  }
                                />
                                {formik1.errors.mobile_number &&
                                formik1.touched.mobile_number ? (
                                  <div className="pho_14_regular text-danger">
                                    {formik1.errors.mobile_number}
                                  </div>
                                ) : null}
                              </Form.Group>
                            </Col>
                          </Row>
                        </Col>
                        <Col md={6}></Col>
                        <Col md={6}>
                          <Form.Group>
                            <TextField
                              id="email"
                              type="email"
                              label="Email Address"
                              variant="outlined"
                              className={`w-100 ${
                                formik1.errors.email && formik1.touched.email
                                  ? "enError"
                                  : ""
                              }`}
                              name="email"
                              onChange={formik1.handleChange}
                              value={formik1.values.email}
                              onBlur={formik1.handleBlur}
                              //onInvalid={formik1.errors.email && formik1.touched.email}
                              isInvalid={
                                formik1.errors.email && formik1.touched.email
                              }
                            />
                            {formik1.errors.email && formik1.touched.email ? (
                              <div className="pho_14_regular text-danger">
                                {formik1.errors.email}
                              </div>
                            ) : null}
                          </Form.Group>
                        </Col>
                        <Col md={6}></Col>
                        <Col md={6}>
                          <Form.Group>
                            <TextField
                              id="first_name"
                              label="First Name"
                              variant="outlined"
                              className={`w-100 ${
                                formik1.errors.first_name &&
                                formik1.touched.first_name
                                  ? "enError"
                                  : ""
                              }`}
                              name="first_name"
                              onChange={formik1.handleChange}
                              value={formik1.values.first_name}
                              onBlur={formik1.handleBlur}
                              //onInvalid={formik1.errors.email && formik1.touched.email}
                              isInvalid={
                                formik1.errors.first_name &&
                                formik1.touched.first_name
                              }
                            />
                            {formik1.errors.first_name &&
                            formik1.touched.first_name ? (
                              <div className="pho_14_regular text-danger">
                                {formik1.errors.first_name}
                              </div>
                            ) : null}
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group>
                            <TextField
                              id="last_name"
                              label="Last Name"
                              variant="outlined"
                              className={`w-100 ${
                                formik1.errors.last_name &&
                                formik1.touched.last_name
                                  ? "enError"
                                  : ""
                              }`}
                              name="last_name"
                              onChange={formik1.handleChange}
                              value={formik1.values.last_name}
                              onBlur={formik1.handleBlur}
                              //onInvalid={formik1.errors.email && formik1.touched.email}
                              isInvalid={
                                formik1.errors.last_name &&
                                formik1.touched.last_name
                              }
                            />
                            {formik1.errors.last_name &&
                            formik1.touched.last_name ? (
                              <div className="pho_14_regular text-danger">
                                {formik1.errors.last_name}
                              </div>
                            ) : null}
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group>
                            <TextField
                              id="password"
                              label="Password"
                              type="password"
                              variant="outlined"
                              autoComplete="new-password"
                              className={`w-100 ${
                                formik1.errors.password &&
                                formik1.touched.password
                                  ? "enError"
                                  : ""
                              }`}
                              name="password"
                              onChange={formik1.handleChange}
                              value={formik1.values.password}
                              onBlur={formik1.handleBlur}
                              isInvalid={
                                formik1.errors.password &&
                                formik1.touched.password
                              }
                            />
                            {formik1.errors.password &&
                            formik1.touched.password ? (
                              <div className="pho_14_regular text-danger">
                                {formik1.errors.password}
                              </div>
                            ) : null}
                          </Form.Group>
                        </Col>
                        <Col md={6}></Col>
                        {/* <Col md={6}>
                          <Form.Group>
                            <TextField
                              label="Address Line 1"
                              type="text"
                              variant="outlined"
                              className="w-100"
                              name="address"
                              onChange={formik1.handleChange}
                              value={formik1.values.address}
                            />
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group>
                            <TextField
                              label="Address Line 2"
                              type="text"
                              variant="outlined"
                              className="w-100"
                              name="address1"
                              onChange={formik1.handleChange}
                              value={formik1.values.address1}
                            />
                          </Form.Group>
                        </Col> */}
                        <Col md={12}>
                          <div className="f14-500 mt-2 mb-1">Location</div>
                        </Col>
                        <Col md={6}>
                          <Form.Group>
                            {/* <TextField
                              label="Country"
                              type="text"
                              variant="outlined"
                              className="w-100"
                              name="city"
                              onChange={formik1.handleChange}
                              value={formik1.values.city}
                              onBlur={formik1.handleBlur}
                              isInvalid={
                                formik1.errors.city && formik1.touched.city
                              }
                            />
                            {formik1.errors.city && formik1.touched.city ? (
                              <div className="pho_14_regular text-danger">
                                {formik1.errors.city}
                              </div>
                            ) : null} */}
                            <FormControl variant="outlined" className="w-100">
                              <InputLabel htmlFor="outlined-Country">
                                Country
                              </InputLabel>

                              <Select
                                value={data.country}
                                //value="101"
                                onChange={onChangeCountry}
                                label="country"
                                inputProps={{
                                  name: "country",
                                  id: "outlined-country",
                                }}
                                IconComponent={KeyboardArrowDownIcon}
                              >
                                {countries.map((country, index) => (
                                  <option key={index} value={country.id}>
                                    {country.name}
                                  </option>
                                ))}
                              </Select>
                            </FormControl>

                            {formik1.errors.country && formik1.touched.country ? (
                              <div className="pho_14_regular text-danger">
                                {formik1.errors.country}
                              </div>
                            ) : null}
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group>
                            {/* <TextField
                              label="State"
                              type="text"
                              variant="outlined"
                              className="w-100"
                              name="state"
                              onChange={formik1.handleChange}
                              value={formik1.values.state}
                              onBlur={formik1.handleBlur}
                              isInvalid={
                                formik1.errors.state && formik1.touched.state
                              }
                            />
                            {formik1.errors.state && formik1.touched.state ? (
                              <div className="pho_14_regular text-danger">
                                {formik1.errors.state}
                              </div>
                            ) : null} */}
                            <FormControl variant="outlined" className="w-100">
                              <InputLabel htmlFor="outlined-state">
                                State
                              </InputLabel>
                              <Select
                                value={data.state}
                                onChange={onChangeState}
                                label="state"
                                inputProps={{
                                  name: "state",
                                  id: "outlined-state",
                                }}
                                IconComponent={KeyboardArrowDownIcon}
                              >
                                {states.map((state, index) => (
                                  <option key={index} value={state.id}>
                                    {state.name}
                                  </option>
                                ))}
                              </Select>
                            </FormControl>
                            {formik1.errors.state && formik1.touched.state ? (
                              <div className="pho_14_regular text-danger">
                                {formik1.errors.state}
                              </div>
                            ) : null}
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group>
                            {/* <TextField
                              label="City"
                              type="text"
                              variant="outlined"
                              className="w-100"
                              name="country"
                              onChange={formik1.handleChange}
                              value={formik1.values.country}
                              onBlur={formik1.handleBlur}
                              isInvalid={
                                formik1.errors.country && formik1.touched.country
                              }
                            />
                            {formik1.errors.country && formik1.touched.country ? (
                              <div className="pho_14_regular text-danger">
                                {formik1.errors.country}
                              </div>
                            ) : null} */}
                            <FormControl variant="outlined" className="w-100">
                              <InputLabel htmlFor="outlined-state">
                                city
                              </InputLabel>
                              <Select
                                value={data.city}
                                onChange={onChangeCity}
                                label="state"
                                inputProps={{
                                  name: "city",
                                  id: "outlined-state",
                                }}
                                IconComponent={KeyboardArrowDownIcon}
                              >
                                {city.map((city, index) => (
                                  <option key={index} value={city.id}>
                                    {city.name}
                                  </option>
                                ))}
                              </Select>
                            </FormControl>
                            {formik1.errors.city && formik1.touched.city ? (
                              <div className="pho_14_regular text-danger">
                                {formik1.errors.city}
                              </div>
                            ) : null}
                          </Form.Group>
                        </Col>
                      </Row>
                      <div className="d-flex align-items-center pt-5">
                        <Button
                          variant="outline-secondary"
                          className="mr-4 px-5 py-2"
                          onClick={(e) =>
                            props.history.push("/superadminallusers")
                          }
                        >
                          Back
                        </Button>
                        <Button
                          variant="danger"
                          className="px-5  py-2"
                          //onClick={(e) => handleShowTab("2")}
                          //type="submit"
                          onClick={() => onClickStepOne()}
                        >
                          Next
                        </Button>
                      </div>
                    </Form>
                  </div>
                )}
                {ShowTab === "2" && (
                  <div className="row">
                    <Form
                      className="col-xl-8 col-lg-10 col-md-12 pb-5"
                      onSubmit={formikStep2.handleSubmit}
                    >
                      <Row>
                        <Col md={12}>
                          <Row>
                            <Col md={6}>
                              <div className="d-flex align-items-center pb-5 pt-3">
                                <div className="enUserPicBox">
                                  {!profilePhoto && (
                                    <Image
                                      src={require("../../../../assets/images/UserManagement/user.svg")}
                                      alt="chairs"
                                      title="chairs"
                                      className="enUserPic"
                                    />
                                  )}
                                  {profilePhoto && (
                                    <Image
                                      src={profilePhoto}
                                      alt="chairs"
                                      title="chairs"
                                      className="enUserPic"
                                    />
                                  )}
                                  <div className="enUploadIcon">
                                    <input
                                      type="file"
                                      accept=".png, .jpg, .jpeg"
                                      //onChange={uploadImage}
                                      onChange={(e) => uploadImage(e)}
                                    />
                                    <Image
                                      src={require("../../../../assets/images/UserManagement/plus.svg")}
                                      alt="chairs"
                                      title="chairs"
                                      className="w-100 h-100"
                                    />
                                  </div>
                                </div>
                                <div className="pl-4">
                                  <div className="f14-400 pb-2">
                                    Select an image, with size less than 2mb.
                                  </div>
                                  <div className="f14-400 opacity5">
                                    Max Dimensions: 1500x1500
                                  </div>
                                </div>
                              </div>
                              <FormControl
                                variant="outlined"
                                className="w-100 mb-4"
                              >
                                <InputLabel htmlFor="outlined-age-native-simple">
                                  Language
                                </InputLabel>
                                <Select
                                  value={state.Language}
                                  onChange={handleChangeLanguage}
                                  label="Language"
                                  inputProps={{
                                    name: "Language",
                                    id: "outlined-age-native-simple",
                                  }}
                                >
                                  <option value="English">English (EN)</option>
                                </Select>
                              </FormControl>
                            </Col>
                          </Row>
                          <div className="f18-700 pb-3">Gender</div>
                          <div className="d-flex flex-wrap">
                            {gender.map((gender, index) => (
                              <div
                                className="enCheckWithText mr-2 mb-2"
                                key={index}
                              >
                                <input
                                  type="radio"
                                  checked={gender.status}
                                  name="gender"
                                  onChange={() =>
                                    handleGenderChange(gender.name)
                                  }
                                  value={formikStep2.values.gender}
                                  onBlur={formikStep2.handleBlur}
                                  onInvalid={
                                    formikStep2.errors.gender &&
                                    formik1.touched.gender
                                  }
                                  isInvalid={
                                    formikStep2.errors.gender &&
                                    formikStep2.touched.gender
                                  }
                                />
                                <label className="d-flex align-items-center">
                                  <Image
                                    src={require("../../../../assets/images/UserManagement/gender-male.svg")}
                                    alt="chairs"
                                    title="chairs"
                                    className="mr-2"
                                  />
                                  {gender.name}
                                </label>
                              </div>
                            ))}
                          </div>
                          {formikStep2.errors.gender ? (
                            <div className="pho_14_regular text-danger">
                              {formikStep2.errors.gender}
                            </div>
                          ) : null}
                          <div className="f18-500 pt-4">Are you over 21?</div>
                          <div className="d-flex align-items-center py-4">
                            <div className="f16-500 mr-2">No</div>
                            <Switch
                              onChange={handleChangeSwitch}
                              checked={are_you_over_21.are_you_over_21}
                              offColor="#EEEEEE"
                              onColor="#EEEEEE"
                              offHandleColor="#212121"
                              onHandleColor="#59F832"
                              handleDiameter={24}
                              uncheckedIcon={false}
                              checkedIcon={false}
                              height={15}
                              width={41}
                              boxShadow="-2px 0px 5px #0000003B"
                              activeBoxShadow="-2px 0px 5px #0000003B"
                              id="material-switch"
                              // disabled={disabled === true ? true : false}
                            />
                            <div className="f16-500 ml-2">Yes</div>
                          </div>
                          <div className="f18-500 pt-4">Your Age</div>
                          <div className="d-flex flex-wrap py-4">
                            {!are_you_over_21.are_you_over_21 ? (
                              <div className="enCheckWithText mr-2 mb-2">
                                <input
                                  type="radio"
                                  checked={age[0].status}
                                  name="age"
                                  onChange={() => handleAgeChange("15-20")}
                                  value={formikStep2.values.age}
                                  onBlur={formikStep2.handleBlur}
                                  isInvalid={
                                    formikStep2.errors.age && formik1.touched.age
                                  }
                                />
                                <label className="d-flex align-items-center justify-content-center">
                                  15 - 20
                                </label>
                              </div>
                            ) : (
                              <Fragment>
                                <div className="enCheckWithText mr-2 mb-2">
                                  <input
                                    type="radio"
                                    name="age"
                                    checked={age[1].status}
                                    onChange={() => handleAgeChange("21-30")}
                                    value={formikStep2.values.age}
                                    onBlur={formikStep2.handleBlur}
                                    isInvalid={
                                      formikStep2.errors.age &&
                                      formik1.touched.age
                                    }
                                  />
                                  <label className="d-flex align-items-center justify-content-center">
                                    21 - 30
                                  </label>
                                </div>
                                <div className="enCheckWithText mr-2 mb-2">
                                  <input
                                    type="radio"
                                    name="age"
                                    checked={age[2].status}
                                    onChange={() => handleAgeChange("31-40")}
                                    value={formikStep2.values.age}
                                    onBlur={formikStep2.handleBlur}
                                    isInvalid={
                                      formikStep2.errors.age &&
                                      formik1.touched.age
                                    }
                                  />
                                  <label className="d-flex align-items-center justify-content-center">
                                    31- 40
                                  </label>
                                </div>
                                <div className="enCheckWithText mr-2 mb-2">
                                  <input
                                    type="radio"
                                    name="age"
                                    checked={age[3].status}
                                    onChange={() => handleAgeChange("41-50")}
                                    value={formikStep2.values.age}
                                    onBlur={formikStep2.handleBlur}
                                    isInvalid={
                                      formikStep2.errors.age &&
                                      formik1.touched.age
                                    }
                                  />
                                  <label className="d-flex align-items-center justify-content-center">
                                    41 - 50
                                  </label>
                                </div>
                                <div className="enCheckWithText mr-2 mb-2">
                                  <input
                                    type="radio"
                                    name="age"
                                    checked={age[4].status}
                                    onChange={() => handleAgeChange("51>")}
                                    value={formikStep2.values.age}
                                    onBlur={formikStep2.handleBlur}
                                    isInvalid={
                                      formikStep2.errors.age &&
                                      formik1.touched.age
                                    }
                                  />
                                  <label className="d-flex align-items-center justify-content-center">
                                    51 {">"}
                                  </label>
                                </div>
                              </Fragment>
                            )}
                          </div>
                          {formikStep2.errors.age ? (
                            <div className="pho_14_regular text-danger">
                              {formikStep2.errors.age}
                            </div>
                          ) : null}
                          <Row>
                            <Col md={12}>
                              <div className="f18-500 pt-4">
                                When is your Birthday?
                              </div>
                            </Col>
                            <Col xl={6} lg={10} md={12}>
                              <Form.Group className="d-flex align-items-center pt-4">
                                <TextField
                                  id="outlined-basic"
                                  label="DD"
                                  variant="outlined"
                                  className="w-100"
                                  name="birthday_day"
                                  onChange={formikStep2.handleChange}
                                  value={formikStep2.values.birthday_day}
                                  onBlur={formikStep2.handleBlur}
                                  isInvalid={
                                    formikStep2.errors.birthday_day &&
                                    formikStep2.touched.birthday_day
                                  }
                                />
                                {formikStep2.errors.birthday_day &&
                                formikStep2.touched.birthday_day ? (
                                  <div className="pho_14_regular text-danger">
                                    {formikStep2.errors.birthday_day}
                                  </div>
                                ) : null}
                                <div className="mx-2">/</div>
                                <TextField
                                  id="outlined-basic"
                                  label="MM"
                                  variant="outlined"
                                  className="w-100"
                                  name="birthday_month"
                                  onChange={formikStep2.handleChange}
                                  value={formikStep2.values.birthday_month}
                                  onBlur={formikStep2.handleBlur}
                                  isInvalid={
                                    formikStep2.errors.birthday_month &&
                                    formikStep2.touched.birthday_month
                                  }
                                />
                                {formikStep2.errors.birthday_month &&
                                formikStep2.touched.birthday_month ? (
                                  <div className="pho_14_regular text-danger">
                                    {formikStep2.errors.birthday_month}
                                  </div>
                                ) : null}
                              </Form.Group>
                            </Col>
                            <Col md={12}>
                              <div className="f18-500 pt-4">
                                When is your Anniversary?
                              </div>
                            </Col>
                            <Col xl={6} lg={10} md={12}>
                              <Form.Group className="d-flex align-items-center pt-4 pb-5">
                                <TextField
                                  id="outlined-basic"
                                  label="DD"
                                  variant="outlined"
                                  className="w-100"
                                  name="anniversary_day"
                                  onChange={formikStep2.handleChange}
                                  value={formikStep2.values.anniversary_day}
                                  onBlur={formikStep2.handleBlur}
                                  isInvalid={
                                    formikStep2.errors.anniversary_day &&
                                    formikStep2.touched.anniversary_day
                                  }
                                />
                                {formikStep2.errors.anniversary_day &&
                                formikStep2.touched.anniversary_day ? (
                                  <div className="pho_14_regular text-danger">
                                    {formikStep2.errors.anniversary_day}
                                  </div>
                                ) : null}

                                <div className="mx-2">/</div>
                                <TextField
                                  id="outlined-basic"
                                  label="MM"
                                  variant="outlined"
                                  className="w-100"
                                  name="anniversary_month"
                                  onChange={formikStep2.handleChange}
                                  value={formikStep2.values.anniversary_month}
                                  onBlur={formikStep2.handleBlur}
                                  isInvalid={
                                    formikStep2.errors.anniversary_month &&
                                    formikStep2.touched.anniversary_month
                                  }
                                />
                                {formikStep2.errors.anniversary_month &&
                                formikStep2.touched.anniversary_month ? (
                                  <div className="pho_14_regular text-danger">
                                    {formikStep2.errors.anniversary_month}
                                  </div>
                                ) : null}
                              </Form.Group>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                      <div className="d-flex align-items-center">
                        <Button
                          variant="outline-secondary"
                          className="mr-4 px-5 py-2"
                          onClick={(e) => handleShowTab("1")}
                        >
                          Back
                        </Button>
                        <Button
                          variant="danger"
                          className="px-5  py-2"
                          type="submit"
                          // onClick={(e) => handleShowTab("3")}
                        >
                          Next
                        </Button>
                      </div>
                    </Form>
                  </div>
                )}
                {ShowTab === "3" && (
                  <div className="row">
                    <Form
                      className="col-xl-8 col-lg-10 col-md-12 pb-5"
                      onSubmit={(e) => onAddOccassion(e)}
                    >
                      {tempInput.length === 0 ? (
                        <div className="col-md-4 pb-5">
                          <Button
                            variant="outline-secondary"
                            className="f16-700 w-100 py-2 mt-3"
                            type="button"
                            onClick={() => handleAddFields()}
                          >
                            Add Occassion
                          </Button>
                        </div>
                      ) : (
                        <></>
                      )}
                      <Row className="pb-5">
                        {tempInput.map((inputField, index) => (
                          <Fragment key={`${inputField}~${index}`}>
                            <Col md={6}>
                              <Form.Group>
                                <TextField
                                  required
                                  id="outlined-basic"
                                  label="Occassion Title"
                                  variant="outlined"
                                  className="w-100"
                                  name="special_occasion"
                                  value={inputField.special_occasion}
                                  onChange={(event) =>
                                    handleInputChange(index, event)
                                  }
                                />
                              </Form.Group>
                              <Form.Group className="d-flex align-items-center">
                                <TextField
                                  type="number"
                                  required
                                  id="outlined-basic"
                                  label="DD"
                                  variant="outlined"
                                  className="w-100"
                                  name="special_occasion_day"
                                  value={inputField.special_occasion_day}
                                  onChange={(event) =>
                                    handleInputChange(index, event)
                                  }
                                />
                                <div className="mx-2">/</div>
                                <TextField
                                  type="number"
                                  required
                                  id="outlined-basic"
                                  label="MM"
                                  variant="outlined"
                                  className="w-100"
                                  name="MM"
                                  value={inputField.special_occasion_month}
                                  onChange={(event) =>
                                    handleInputChange(index, event)
                                  }
                                />
                              </Form.Group>
                              <Button
                                variant="outline-secondary"
                                className="f16-700 w-100 py-2 mt-3"
                                type="submit"
                                onSubmit={(e) => onAddOccassion(e)}
                              >
                                Save
                              </Button>
                            </Col>
                          </Fragment>
                        ))}
                        <Col md={12}>
                          <hr />
                          <Row>
                            {inputFields.map((inputField, index) => (
                              <Fragment key={`${inputField}~${index}`}>
                                <Col md={6}>
                                  <div className="enShadowBox w-100">
                                    <div className="f16-700">
                                      {inputField.special_occasion}
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between">
                                      <div className="f15-400 opacity5">
                                        {inputField.special_occasion_day} /{" "}
                                        {inputField.special_occasion_month}
                                      </div>
                                      <div className="d-flex align-items-center">
                                        <Button
                                          variant="link"
                                          className="f15-700 text-blue"
                                          onClick={() =>
                                            onEditInputField(index)
                                          }
                                        >
                                          Edit
                                        </Button>{" "}
                                        <div className="opacity5">|</div>
                                        <Button
                                          variant="link"
                                          className="f15-700 text-red"
                                          onClick={() =>
                                            onRemoveInputField(index)
                                          }
                                        >
                                          Remove
                                        </Button>
                                      </div>
                                    </div>
                                  </div>
                                </Col>
                              </Fragment>
                            ))}
                          </Row>
                        </Col>
                      </Row>
                      <div className="d-flex align-items-center">
                        <Button
                          variant="outline-secondary"
                          className="mr-4 px-5 py-2"
                          onClick={(e) => handleShowTab("2")}
                        >
                          Back
                        </Button>
                        <Button
                          variant="danger"
                          className="px-5  py-2"
                          onClick={(e) => handleShowTab("4")}
                        >
                          Next
                        </Button>
                      </div>
                    </Form>
                  </div>
                )}
                {ShowTab === "4" && (
                  <div className="row">
                    <Form className="col-xl-8 col-lg-10 col-md-12 pb-5">
                      <div className="f18-700 mb-3">Days you eat out?</div>
                      <div className="enMaxWidth360 mb-4">
                        {days.map((day, index) => (
                          <div
                            className="enCheckWithText"
                            key={index}
                            onClick={() => onChangeDaysEatOut(day)}
                          >
                            <input type="checkbox" checked={day.status} />
                            <label>{day.name}</label>
                          </div>
                        ))}
                      </div>
                      <div className="f18-700 mb-3">Popular Cuisines</div>
                      <div className="mb-4">
                        <Row>
                          {selectedCruisines.map((item, index) => (
                            <Col md={4} key={index}>
                              <div className="enCheckWithText w-100">
                                <input type="checkbox" disabled />
                                <label className="w-100">{item.name}</label>
                                <IconButton className="enCloseIcon">
                                  <Image
                                    src={require("../../../../assets/images/UserManagement/en_close.svg")}
                                    alt="Close"
                                    title="Close"
                                    onClick={() => onRemoveCruises(item.id)}
                                  />
                                </IconButton>
                              </div>
                            </Col>
                          ))}
                        </Row>
                        <div className="enScrollBox">
                          <Scrollbars style={{ width: "100%", height: 222 }}>
                            <Row className="m-0 py-3">
                              {popularCuisines.map((item, index) => (
                                <Col md={4} className="pb-3" key={index}>
                                  <div
                                    className="enCheckWithText w-100"
                                    onChange={() =>
                                      onChangeAddCrusines(item.name, item.id)
                                    }
                                  >
                                    <input
                                      type="checkbox"
                                      disabled={item.status}
                                      checked={item.status}
                                    />
                                    <label className="w-100">{item.name}</label>
                                  </div>
                                </Col>
                              ))}
                            </Row>
                          </Scrollbars>
                        </div>
                      </div>
                      <div className="f18-700 mb-3">Your Favorite Places</div>
                      <div className="mb-4">
                        <Row>
                          {selectedFavPlaces.map((item, index) => (
                            <Col md={4} key={index}>
                              <div className="enCheckWithText w-100">
                                <input type="checkbox" disabled />
                                <label className="w-100">{item.name}</label>
                                <IconButton className="enCloseIcon">
                                  <Image
                                    src={require("../../../../assets/images/UserManagement/en_close.svg")}
                                    alt="Close"
                                    title="Close"
                                    onClick={() => onRemoveFavPlaces(item.id)}
                                  />
                                </IconButton>
                              </div>
                            </Col>
                          ))}
                        </Row>
                        <div className="enScrollBox">
                          <Scrollbars style={{ width: "100%", height: 222 }}>
                            <Row className="m-0 py-3">
                              {favPlaces.map((item, index) => (
                                <Col md={4} className="pb-3" key={index}>
                                  <div
                                    className="enCheckWithText w-100"
                                    onChange={() =>
                                      onChangeAddFavPlaces(item.name, item.id)
                                    }
                                  >
                                    <input
                                      type="checkbox"
                                      disabled={item.status}
                                      checked={item.status}
                                    />
                                    <label className="w-100">{item.name}</label>
                                  </div>
                                </Col>
                              ))}
                            </Row>
                          </Scrollbars>
                        </div>
                      </div>
                      <div className="f18-700 mb-3">
                        Do you have Dietary Preferences?
                      </div>
                      <div className="d-flex align-items-center pb-4">
                        <div className="f16-500 mr-2">No</div>
                        <Switch
                          onChange={handleChangeSwitchDietary}
                          checked={checkboxDietary.checkboxDietary}
                          offColor="#EEEEEE"
                          onColor="#EEEEEE"
                          offHandleColor="#212121"
                          onHandleColor="#59F832"
                          handleDiameter={24}
                          uncheckedIcon={false}
                          checkedIcon={false}
                          height={15}
                          width={41}
                          boxShadow="-2px 0px 5px #0000003B"
                          activeBoxShadow="-2px 0px 5px #0000003B"
                          id="material-switch"
                          // disabled={disabled === true ? true : false}
                        />
                        <div className="f16-500 ml-2">Yes</div>
                      </div>
                      {checkboxDietary.checkboxDietary && (
                        <div className="mb-4">
                          <Row>
                            {selectedDietaryPref.map((item, index) => (
                              <Col md={4} key={index}>
                                <div className="enCheckWithText w-100">
                                  <input type="checkbox" disabled />
                                  <label className="w-100">{item.name}</label>
                                  <IconButton className="enCloseIcon">
                                    <Image
                                      src={require("../../../../assets/images/UserManagement/en_close.svg")}
                                      alt="Close"
                                      title="Close"
                                      onClick={() =>
                                        onRemoveDietaryPref(item.id)
                                      }
                                    />
                                  </IconButton>
                                </div>
                              </Col>
                            ))}
                          </Row>
                          <div className="enScrollBox">
                            <Scrollbars style={{ width: "100%", height: 222 }}>
                              <Row className="m-0 py-3">
                                {dietaryPref.map((item, index) => (
                                  <Col md={4} className="pb-3" key={index}>
                                    <div
                                      className="enCheckWithText w-100"
                                      onChange={() =>
                                        onChangeAddDietaryPref(
                                          item.name,
                                          item.id
                                        )
                                      }
                                    >
                                      <input
                                        type="checkbox"
                                        disabled={item.status}
                                        checked={item.status}
                                      />
                                      <label className="w-100">
                                        {item.name}
                                      </label>
                                    </div>
                                  </Col>
                                ))}
                              </Row>
                            </Scrollbars>
                          </div>
                        </div>
                      )}
                      <div className="f18-700 mb-3">Do you have Allergies?</div>
                      <div className="d-flex align-items-center pb-5">
                        <div className="f16-500 mr-2">No</div>
                        <Switch
                          onChange={handleChangeSwitchAllergies}
                          checked={checkedBoxAllergies.checkedBoxAllergies}
                          offColor="#EEEEEE"
                          onColor="#EEEEEE"
                          offHandleColor="#212121"
                          onHandleColor="#59F832"
                          handleDiameter={24}
                          uncheckedIcon={false}
                          checkedIcon={false}
                          height={15}
                          width={41}
                          boxShadow="-2px 0px 5px #0000003B"
                          activeBoxShadow="-2px 0px 5px #0000003B"
                          id="material-switch"
                          // disabled={disabled === true ? true : false}
                        />
                        <div className="f16-500 ml-2">Yes</div>
                      </div>
                      {checkedBoxAllergies.checkedBoxAllergies && (
                        <div className="mb-4">
                          <Row>
                            {selectedAllergies.map((item, index) => (
                              <Col md={4} key={index}>
                                <div className="enCheckWithText w-100">
                                  <input type="checkbox" disabled />
                                  <label className="w-100">{item.name}</label>
                                  <IconButton className="enCloseIcon">
                                    <Image
                                      src={require("../../../../assets/images/UserManagement/en_close.svg")}
                                      alt="Close"
                                      title="Close"
                                      onClick={() => onRemoveAllergies(item.id)}
                                    />
                                  </IconButton>
                                </div>
                              </Col>
                            ))}
                          </Row>
                          <div className="enScrollBox">
                            <Scrollbars style={{ width: "100%", height: 222 }}>
                              <Row className="m-0 py-3">
                                {allergies.map((item, index) => (
                                  <Col md={4} className="pb-3" key={index}>
                                    <div
                                      className="enCheckWithText w-100"
                                      onChange={() =>
                                        onChangeAddAllergies(item.name, item.id)
                                      }
                                    >
                                      <input
                                        type="checkbox"
                                        disabled={item.status}
                                        checked={item.status}
                                      />
                                      <label className="w-100">
                                        {item.name}
                                      </label>
                                    </div>
                                  </Col>
                                ))}
                              </Row>
                            </Scrollbars>
                          </div>
                        </div>
                      )}
                      <div className="d-flex align-items-center">
                        <Button
                          variant="outline-secondary"
                          className="btn-lg mr-4 px-5 "
                          onClick={(e) => handleShowTab("3")}
                        >
                          Back
                        </Button>
                        <Button
                          variant="danger"
                          className="btn-lg px-5"
                          onClick={(e) => handleShowTab("5")}
                        >
                          Next
                        </Button>
                      </div>
                    </Form>
                  </div>
                )}
                {ShowTab === "5" && (
                  <div className="row">
                    <Form className="col-xl-8 col-lg-10 col-md-12 pb-5">
                      <div className="f18-700 mb-3">Your Favourite Chains</div>
                      <div className="mb-5">
                        <Row>
                          {selectedFavChains.map((item, index) => (
                            <Col md={6} lg={4} key={index}>
                              <div className="enCheckWithText w-100">
                                <input type="checkbox" disabled />
                                <label className="w-100 d-flex align-items-center">
                                  <Image
                                    //src={require("../../../../assets/images/UserManagement/fhr2.png")}
                                    src={item.icon}
                                    className="enFHRIMG"
                                    alt="Close"
                                    title="Close"
                                  />
                                  {item.name}
                                </label>
                                <IconButton className="enCloseIcon">
                                  <Image
                                    src={require("../../../../assets/images/UserManagement/en_close.svg")}
                                    alt="Close"
                                    title="Close"
                                    onClick={() => onRemoveFavChains(item.id)}
                                  />
                                </IconButton>
                              </div>
                            </Col>
                          ))}
                        </Row>
                        <div className="enScrollBox">
                          <Scrollbars style={{ width: "100%", height: 222 }}>
                            <Row className="m-0 py-3">
                              {favChains.map((item, index) => (
                                <Col md={6} lg={4} className="pb-3" key={index}>
                                  <div
                                    className="enCheckWithText w-100"
                                    onChange={() =>
                                      onChangeAddFavChains(
                                        item.name,
                                        item.id,
                                        item.icon
                                      )
                                    }
                                  >
                                    <input
                                      type="checkbox"
                                      checked={item.status}
                                      disabled={item.status}
                                    />
                                    <label className="w-100 d-flex align-items-center">
                                      <Image
                                        src={item.icon}
                                        alt="icon"
                                        title="icon"
                                        className="enFHRIMG"
                                      />
                                      {item.name}
                                    </label>
                                  </div>
                                </Col>
                              ))}
                            </Row>
                          </Scrollbars>
                        </div>
                      </div>
                      <div className="d-flex align-items-center">
                        <Button
                          variant="outline-secondary"
                          className="btn-lg mr-4 px-5"
                          onClick={(e) => handleShowTab("4")}
                        >
                          Back
                        </Button>
                        <Button
                          variant="danger"
                          className="btn-lg px-5"
                          // onClick={CloseEdit}
                          onClick={() => submitData()}
                        >
                          Save
                        </Button>
                      </div>
                    </Form>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

AddUser.propTypes = {
  auth: PropTypes.object.isRequired,
  addNewUser: PropTypes.func.isRequired,
  getCrusines: PropTypes.func.isRequired,
  getFavPlaces: PropTypes.func.isRequired,
  getFavChains: PropTypes.func.isRequired,
  getDietaryPref: PropTypes.func.isRequired,
  getAllergies: PropTypes.func.isRequired,
  checkIfEmailExists: PropTypes.func.isRequired,
  checkIfPhoneExists: PropTypes.func.isRequired,
  getAllCountries: PropTypes.func.isRequired,
  getAllStateFromCountry: PropTypes.func.isRequired,
  getAllCityFromState: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, {
  addNewUser,
  getCrusines,
  getFavPlaces,
  getFavChains,
  getDietaryPref,
  getAllergies,
  checkIfEmailExists,
  checkIfPhoneExists,
  getAllCountries,
  getAllStateFromCountry,
  getAllCityFromState,
})(AddUser);
